/** Ray-casting point-in-polygon test (lat/lng coordinates). */
export function isPointInPolygon(point, polygon) {
  if (!point || !polygon || polygon.length < 3) return false;
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].lat;
    const yi = polygon[i].lng;
    const xj = polygon[j].lat;
    const yj = polygon[j].lng;
    const intersect = ((yi > point.lng) !== (yj > point.lng))
      && (point.lat < (xj - xi) * (point.lng - yi) / (yj - yi) + xi);
    if (intersect) inside = !inside;
  }
  return inside;
}

export function devicesInPolygon(devices, coordinates) {
  if (!coordinates || coordinates.length < 3) return [];
  return (devices || []).filter((device) => {
    if (device.lat == null || device.lng == null) return false;
    return isPointInPolygon({ lat: device.lat, lng: device.lng }, coordinates);
  });
}
